

gsap.registerPlugin(ScrollTrigger, SplitText);



/* home_banner */
let home_banner;
// 断点
const BREAKPOINT = 768;
function initBannerSwiper() {
  // 销毁旧实例
  if(home_banner) home_banner.destroy(true, true);
  const isMobile = window.innerWidth < BREAKPOINT;
  const baseOption = {
    slidesPerView: 1,
    centeredSlides: false,
    loop: false,
    navigation: {
      nextEl: '.buttonforbanner .right_btn',
      prevEl: '.buttonforbanner .left_btn',
    },
    pagination: {
      el: '.dotsforbanner',
      clickable: true,
      renderBullet: function (index, className) {
        return '<span class="' + className + '" ></span>';
      },
    }
  };

  home_banner = new Swiper('.home_banner_swper', {
    ...baseOption,
    speed: isMobile ? 0 : 800,
    allowTouchMove: true,
    watchSlidesProgress: false,
    on: {
      slideChangeTransitionStart: function () {
        const prevRealIdx = this.previousRealIndex;
        const activeRealIdx = this.realIndex;
        const prevSlide = this.slides[prevRealIdx];
        const activeSlide = this.slides[activeRealIdx];
        if (!prevSlide || !activeSlide) return;
        const prevText = prevSlide.querySelector('.text_box');
        const prevImg = prevSlide.querySelector('.product_img');
        const nextText = activeSlide.querySelector('.text_box');
        const nextImg = activeSlide.querySelector('.product_img');
        gsap.killTweensOf([prevText, prevImg, nextText, nextImg]);
        const isNext = activeRealIdx > prevRealIdx;
        const imgOutX = isNext ? -80 : 80;
        gsap.to(prevText, { opacity: 0, y: -40, duration: 0.8, ease: "power2.in" });
        gsap.to(prevImg, {
          opacity: 0,
          x: imgOutX,
          xPercent: -50,
          duration: 0.8,
          ease: "power2.in"
        });
        gsap.set(nextText, { opacity: 0, y: 40 });
        gsap.set(nextImg, {
          opacity: 0,
          x: -60,
          xPercent: -50,
          rotate: 25
        });
      },
      slideChangeTransitionEnd: function () {
        const activeSlide = this.slides[this.realIndex];
        const textDom = activeSlide.querySelector('.text_box');
        const imgDom = activeSlide.querySelector('.product_img');
        if (!textDom || !imgDom) return;
        gsap.killTweensOf([textDom, imgDom]);
        gsap.to(textDom, { opacity: 1, y: 0, duration: 0.8, ease: "power2.out" });
        const imgTl = gsap.to(imgDom, {
          opacity: 1,
          x: 0,
          duration: 0.8,
          delay: 0.15,
          xPercent: -50,
          ease: "power2.out",
        });
        // PC才添加yoyo浮动，移动端不循环
        if(!isMobile){
          imgTl.then(()=>{
            gsap.to(imgDom, {
              y: "-2rem",
              scale: 1.06,
              duration: 3,
              xPercent: -50,
              ease: "ease-in-out",
              repeat: -1,
              yoyo: true
            })
          })
        }
      }
    }
  });

  // 首屏动画（PC + Mobile统一执行）
  function runFirstBannerAnim() {
    const firstSlide = home_banner.slides[home_banner.realIndex];
    const textDom = firstSlide.querySelector('.text_box');
    const imgDom = firstSlide.querySelector('.product_img');
    if (!textDom || !imgDom) return;
    gsap.set(imgDom, { xPercent: -50, rotate: 25 });
    gsap.to(textDom, { opacity: 1, y: 0, duration: 0.8, ease: "power2.out" });
    const imgTl = gsap.to(imgDom, {
      opacity: 1,
      x: 0,
      duration: 0.8,
      delay: 0.15,
      xPercent: -50,
      ease: "power2.out",
    });
    if(!isMobile){
      imgTl.then(()=>{
        gsap.to(imgDom, {
          y: "-2rem",
          scale: 1.06,
          duration: 3,
          xPercent: -50,
          ease: "ease-in-out",
          repeat: -1,
          yoyo: true
        })
      })
    }
  }
  const firstImg = home_banner.slides[home_banner.realIndex].querySelector('.product_img');
  if (firstImg.complete) {
    runFirstBannerAnim();
  } else {
    firstImg.onload = runFirstBannerAnim;
    setTimeout(runFirstBannerAnim, 300);
  }
}
// 初始化
initBannerSwiper();
// 窗口resize，销毁重建
let resizeTimerIndex;
window.addEventListener('resize', ()=>{
  clearTimeout(resizeTimerIndex);
  resizeTimerIndex = setTimeout(initBannerSwiper, 250);
})






/* */

// home_experience_main
function startTitleMarquee() {
    const titleWrap = document.querySelector(".home_experience_main .title");
    const scrollBox = titleWrap?.querySelector(".title_inner");

    if (!titleWrap || !scrollBox) {
        setTimeout(startTitleMarquee, 300);
        return;
    }

    // ✅关键：只保留原生节点，把所有克隆出来的子元素全部删掉
    // 找原始节点：带自定义标记，没有标记的都是克隆出来的
    let originNodes = Array.from(scrollBox.children).filter(el => !el.dataset.clone);

    // 如果第一次执行没有标记，打上标记
    if(originNodes.length === 0){
        originNodes = Array.from(scrollBox.children);
        originNodes.forEach(n=> n.dataset.clone = "origin");
    }
    // 清空容器，只放回原始DOM，清除所有克隆副本
    scrollBox.innerHTML = '';
    originNodes.forEach(item=> scrollBox.appendChild(item));


    // 复制两份用于无缝循环，打上克隆标记
    originNodes.forEach(item => {
        const c1 = item.cloneNode(true);
        c1.dataset.clone = "copy";
        scrollBox.appendChild(c1);

        const c2 = item.cloneNode(true);
        c2.dataset.clone = "copy";
        scrollBox.appendChild(c2);
    });


    setTimeout(() => {
        // 单项宽度 = 一屏宽度 100vw
        const singleItemWidth = window.innerWidth;
        // 原始一组总宽度
        const groupWidth = singleItemWidth * originNodes.length;

        const titleAnim = gsap.to(scrollBox, {
            x: -groupWidth,
            duration: 26,
            ease: "none",
            repeat: -1,
            onRepeat: () => {
                gsap.set(scrollBox, { x: 0 });
            }
        });

        // 保存处理函数方便后续removeEventListener
        const onMouseEnter = () => titleAnim.pause();
        const onMouseLeave = () => titleAnim.resume();

        titleWrap.addEventListener("mouseenter", onMouseEnter);
        titleWrap.addEventListener("mouseleave", onMouseLeave);


        // ✅ resize处理：移除once:true，加防抖，销毁动画+清理事件，再重启
        let resizeTimer = null;
        function handleResize(){
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(()=>{
                // 杀掉动画
                titleAnim.kill();
                gsap.set(scrollBox, { x: 0 });
                // 移除旧鼠标事件，防止重复绑定
                titleWrap.removeEventListener("mouseenter", onMouseEnter);
                titleWrap.removeEventListener("mouseleave", onMouseLeave);
                // 重新初始化
                startTitleMarquee();
            }, 150);
        }
        // 不要 once:true
        window.addEventListener("resize", handleResize);

    }, 100);
}
startTitleMarquee();

//VIDEO
//VIDEO

// ============ 数据源唯一真相源 ============
const videoSourceList = [
  "https://cdn.shopify.com/videos/c/o/v/8794bac04e234534afe2d9ec6c1e157b.mp4",
  "https://cdn.shopify.com/videos/c/o/v/86448529614f4c7981714abcd17c9a9e.mp4",
  "https://cdn.shopify.com/videos/c/o/v/559b005a0ceb488b8688f5e9f055c3f2.mp4",
  "https://cdn.shopify.com/videos/c/o/v/4ecc828b187e4a66854b136d4f15bca0.mp4",
  "https://cdn.shopify.com/videos/c/o/v/738a53ef1c054fdb971b1395dc5bcfdc.mp4",
  "https://cdn.shopify.com/videos/c/o/v/4d836afdcbc04b5ba8b36cb043568b99.mp4"
];
const imageSourceList = [];
let mainVideoSwiper;
let leftVideoSwiper;
let rightVideoSwiper;
let img2RotateDeg = 0;
// 记录已经处理完成的真实下标，loop防重复累加
let handledRealIndex = 0;
// 修改：取外层容器，实际操作内部img标签
const img2Wrap = document.querySelector('.video_main .img2');
const img2Dom = img2Wrap ? img2Wrap.querySelector('img') : null;

// 根据宽度获取配置
function getSwiperConfig(){
  const isMobile = window.innerWidth <= 750;
  const base = {
    loop: true,
    initialSlide:0
  };
  if(isMobile){
    // 移动端：垂直
    return {
      main:{
        loop: base.loop,
        initialSlide: base.initialSlide,
        direction:"vertical",
        allowTouchMove: true,
        navigation: {
          nextEl: '.video_main .swiper-button-right',
          prevEl: '.video_main .swiper-button-left'
        },
        on: {
          init: function(swiper){
            if(imageSourceList.length > 0) return;
            swiper.slides.forEach(function(slideDom){
              if(slideDom.classList.contains('swiper-slide-duplicate')) return;
              const imgDom = slideDom.querySelector('.img-mask-wrap img');
              imageSourceList.push(imgDom ? imgDom.src : "");
            });
            console.log("采集完成 imageSourceList",imageSourceList);
          }
        }
      },
      sub:{
        loop:true,
        simulateTouch: false,
        allowTouchMove: false,
        direction:"vertical"
      }
    }
  }else{
    // PC水平
    return {
      main:{
        loop: base.loop,
        initialSlide: base.initialSlide,
        direction:"horizontal",
        allowTouchMove: true,
        navigation: {
          nextEl: '.video_main .swiper-button-left',
          prevEl: '.video_main .swiper-button-right'
        },
        on: {
          init: function(swiper){
            if(imageSourceList.length > 0) return;
            swiper.slides.forEach(function(slideDom){
              if(slideDom.classList.contains('swiper-slide-duplicate')) return;
              const imgDom = slideDom.querySelector('.img-mask-wrap img');
              imageSourceList.push(imgDom ? imgDom.src : "");
            });
            console.log("采集完成 imageSourceList",imageSourceList);
          }
        }
      },
      sub:{
        loop:true,
        simulateTouch: false,
        allowTouchMove: false,
        direction:"horizontal"
      }
    }
  }
}

// 创建/重建所有swiper实例
function createAllSwiper(){
  if(mainVideoSwiper && mainVideoSwiper.destroy) mainVideoSwiper.destroy(true,true);
  if(leftVideoSwiper && leftVideoSwiper.destroy) leftVideoSwiper.destroy(true,true);
  if(rightVideoSwiper && rightVideoSwiper.destroy) rightVideoSwiper.destroy(true,true);
  const cfg = getSwiperConfig();
  mainVideoSwiper = new Swiper('.video_s1', cfg.main);
  leftVideoSwiper = new Swiper('.video_s_left', cfg.sub);
  rightVideoSwiper = new Swiper('.video_s_right', cfg.sub);
  mainVideoSwiper.controller.control = [ leftVideoSwiper, rightVideoSwiper ];
  // resize重建，统一重置旋转状态
  if(img2Dom){
    img2RotateDeg = 0;
    handledRealIndex = mainVideoSwiper.realIndex;
    gsap.set(img2Dom, {transformOrigin:"center center", rotate:0});
  }
}

createAllSwiper();

window.addEventListener('resize',function(){
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function(){
    createAllSwiper();
    bindHoverEvent();
  },250);
});

document.querySelector('.video_s_left').addEventListener('click',function(){
  mainVideoSwiper.slidePrev();
});
document.querySelector('.video_s_right').addEventListener('click',function(){
  mainVideoSwiper.slideNext();
});

const videoMainWrap = document.querySelector('.video_main');
const leftWrap = document.querySelector('.video_s_left');
const rightWrap = document.querySelector('.video_s_right');

function bindHoverEvent(){
  const isMobile = window.innerWidth <=750;
  if(isMobile) return;
  leftWrap.addEventListener('mouseenter', function (){
    videoMainWrap.classList.add('hover-left');
    videoMainWrap.classList.remove('hover-right');
  });
  leftWrap.addEventListener('mouseleave', function (e){
    if(!leftWrap.contains(e.relatedTarget)){
      videoMainWrap.classList.remove('hover-left');
    }
  });
  rightWrap.addEventListener('mouseenter', function (){
    videoMainWrap.classList.add('hover-right');
    videoMainWrap.classList.remove('hover-left');
  });
  rightWrap.addEventListener('mouseleave', function (e){
    if(!rightWrap.contains(e.relatedTarget)){
      videoMainWrap.classList.remove('hover-right');
    }
  });
}
bindHoverEvent();

// ========== 视频弹窗 原生JS逻辑 ==========
const productVideoEl = document.querySelector('.productVideo');
const videoBoxEl = productVideoEl.querySelector('.video-box');
const videoEl = productVideoEl.querySelector('video');
const closeBtn = productVideoEl.querySelector('.close');
const playBtn = document.querySelector('.video_play');

function getCurrentSlideVideoSrc(){
  const realIndex = mainVideoSwiper.realIndex;
  return videoSourceList[realIndex] || '';
}
function getCurrentSlideImageSrc(){
  const realIndex = mainVideoSwiper.realIndex;
  return imageSourceList[realIndex] || '';
}

// 拖拽实时跟随旋转：仅手动拖拽swiper.isDragging才执行
mainVideoSwiper.on('progress', function(swiper){
  const isMobile = window.innerWidth <=750;
  if(!isMobile || !img2Dom) return;
  if(!swiper.isDragging) return;

  const baseDeg = img2RotateDeg - 90;
  const targetDeg = img2RotateDeg;
  const currentFollowDeg = baseDeg + (targetDeg - baseDeg) * swiper.progress;
  gsap.set(img2Dom, {
    rotate: currentFollowDeg,
    transformOrigin:"center center"
  });
});

// 【唯一可靠入口】动画100%结束，落在真实slide之后，才做角度累加
mainVideoSwiper.on('slideChangeTransitionEnd',function(){
  const idx = mainVideoSwiper.realIndex;
  const currVideo = videoSourceList[idx];
  const currImg = imageSourceList[idx];
  console.log('slideChangeTransitionEnd 下标', idx, currVideo, currImg);
  const isMobile = window.innerWidth <=750;
  if(isMobile && img2Dom){
    // 防loop重复触发：只有当前realIndex没有被处理过，才+90
    if(idx !== handledRealIndex){
      img2RotateDeg += 90;
      handledRealIndex = idx;
    }
    const targetDeg = img2RotateDeg;
    gsap.to(img2Dom,{
      duration:0.25,
      ease:"power2.out",
      transformOrigin:"center center",
      rotate: targetDeg,
      onComplete:function(){
        img2RotateDeg = img2RotateDeg % 360;
        gsap.set(img2Dom, { rotate: img2RotateDeg });
      }
    });
  }
});

function openVideoModal(){
  const src = getCurrentSlideVideoSrc();
  if(!src) return;
  videoEl.src = src;
  productVideoEl.classList.add('show');
  gsap.fromTo(videoBoxEl,{y:120},{y:0, ease:"power2.out", duration:1});
  videoEl.play().catch(function(){});
  document.body.style.overflowY = 'hidden';
}
function closeVideoModal(){
  productVideoEl.classList.remove('show');
  videoEl.pause();
  videoEl.src = '';
  document.body.style.overflowY = '';
  gsap.set(videoBoxEl, {y:120});
}
playBtn.addEventListener('click', openVideoModal);
closeBtn.addEventListener('click', closeVideoModal);
productVideoEl.addEventListener('click', function(e){
  if(e.target === productVideoEl){
    closeVideoModal();
  }
});






//best_selling
const best_selling_productsswiper = new Swiper('.best_selling_products .swiper', {
  slidesPerView:4,
  loop: true,
  allowTouchMove: true,
  spaceBetween:40,
  initialSlide:0,
  breakpoints: {
    0: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    750: {
      slidesPerView: 4,
      spaceBetween: 40
    }
  },
  navigation: {
    nextEl: '.best_selling_products .swiper-right',
    prevEl: '.best_selling_products .swiper-left',
  }
});


document.addEventListener("DOMContentLoaded", ()=>{
  // 产品图片滚动入场
  gsap.set(".best_selling_products .img_box img", {
    yPercent: 60,
    opacity: 0
  });

  ScrollTrigger.batch(".best_selling_products .swiper-slide",{
    start:"50% 80%",
    //markers: true,
    once:true,
    onEnter:(elements)=>{
      const targets = elements.map(el => el.querySelector(".img_box img"));
      gsap.to(targets,{
        yPercent: 0,
        opacity:1,
        duration:1.1,
        ease:"power3.out",
        stagger:0.3
      })
    }
  });


  // -------- 圆弧遮罩 + hover_a顺序动画 --------
  const slides = document.querySelectorAll(".best_selling_products .swiper-slide");
  const maskDuration = 1;    //圆弧遮罩时长
  const badgeDuration = 0.1;    //hover_a出场时长
  const totalPlayTime = maskDuration + badgeDuration;

  slides.forEach(slide=>{
    const link = slide.querySelector("a");
    const href = link.getAttribute("href");
    const hoverWrap = slide.querySelector(".slide_hover_wrap");
    const hoverBadge = slide.querySelector(".hover_a");

    const tlHover = gsap.timeline({paused:true});

    //①先播放圆弧遮罩展开
    tlHover.to(hoverWrap,{
      "clipPath":"ellipse(150% 150% at 50% 100%)",
      duration: maskDuration,
      ease:"power2.out"
    })
    //②遮罩动画结束后，hover_a从上往下落出来
    .to(hoverBadge,{
      opacity:1,
      y:0,
      duration: badgeDuration,
      ease:"power2.out"
    },"-=0.55");

    // PC hover 播放正向时间线
    slide.addEventListener("mouseenter", ()=>{
      if(window.matchMedia("(min-width:992px)").matches){
        tlHover.play();
      }
    })
    // mouseleave 反向倒放：先收回hover_a，再收回遮罩
    slide.addEventListener("mouseleave", ()=>{
      if(window.matchMedia("(min-width:992px)").matches){
        tlHover.reverse();
      }
    })

    // 移动端点击，完整播放整套动画，完成后跳转
    slide.addEventListener("click",function(e){
      if(window.matchMedia("(min-width:992px)").matches){
        return;
      }
      e.preventDefault();
      tlHover.play();
      setTimeout(()=>{
        window.location.href = href;
      }, totalPlayTime * 1000);
    })
  })
})

//
document.addEventListener("DOMContentLoaded", () => {
  const chars = gsap.utils.toArray(".zenglide_main .char");

  gsap.timeline({
    repeat: -1, // -1 = 无限循环
  })
  .fromTo(chars,
    { opacity: 0 },
    {
      opacity: 1,
      duration: 1,
      stagger: 0.15,
      ease: "power1.out"
    }
  )
  .to(chars, {
    opacity: 0,
    duration: 1,
    stagger: 0.12,
    ease: "power2.in"
  });
});



/* */
const reviewList = [
    {
        star:5,
        title:"LOOKS LIKE NOTHING ELSE",
        content:"The design caught my eye right away. It feels playful, original, and much more personal than the usual devices I see.",
        author:"Tracy Yu",
        date:"05/08/2026"
    },
    {
        star:5,
        title:"A FLAVOR I’D CHOOSE AGAIN",
        content:"Bright, smooth, and full of character. It’s the kind of flavor that keeps things interesting without feeling like too much.",
        author:"Angela",
        date:"05/08/2026"
    },
    {
        star:4.7,
        title:"THIS ONE JUST FEELS LIKE ME",
        content:"From the look to the feel, everything simply clicks. MERRYMI makes it easy to find something that matches my style and mood.",
        author:"PollyAnn",
        date:"05/08/2026"
    },
    {
        star:5,
        title:"Reliable Every Day",
        content:"The performance feels steady and dependable. The flavor stays clear, the draw remains smooth, and I have not had to worry about leaks or sudden changes during daily use.",
        author:"Daniel M",
        date:"21/02/2026"
    },
    {
        star:5,
        title:"Simple, Smooth, and Consistent",
        content:"What I like most is how effortless it feels. The draw is smooth, the flavor stays consistent, and everything works the way I expect without needing constant adjustment.",
        author:"Kevin L",
        date:"18/01/2026"
    },
];

function renderStar(count) {
    let html = '';
    const val = Math.floor(count * 2) / 2;
    const full = Math.floor(val);
    const hasHalf = (val - full) === 0.5;

    for (let i = 0; i < full; i++) {
        html += `<span class="star star--on"></span>`;
    }
    if (hasHalf) {
        html += `<span class="star star--half"></span>`;
    }
    const rest = 5 - full - (hasHalf ? 1 : 0);
    for (let i = 0; i < rest; i++) {
        html += `<span class="star star--off"></span>`;
    }
    // 追加tooltip，保留1位小数展示分数
    html += `<span class="star-score-tooltip">${count.toFixed(1)}</span>`;
    return html;
}

document.addEventListener('DOMContentLoaded', function () {
    const swiperEl = document.querySelector('.review-swiper');
    const wrapper = swiperEl.querySelector('.swiper-wrapper');
    const playPauseBtn = document.querySelector('.carousel-play-pause');

    // 用户手动暂停标记
    let isUserPaused = false;

    let slideHtml = '';
    reviewList.forEach(item=>{
        slideHtml += `
        <div class="swiper-slide">
            <div class="review-item">
                <div class="review-item__rating">
                    ${renderStar(item.star)}
                </div>
                <div class="review-item__content">
                    <div class="review-item__title line-clamp-1">${item.title}</div>
                    <div class="review-item__body line-clamp-3">
                        <p>${item.content}</p>
                    </div>
                </div>
            </div>
            <div class="review-item__author-wrap">
                <div class="review-item__author"> ${item.author} </div>
                <div class="review-item__date">${item.date}</div>
            </div>
        </div>
        `;
    });
    wrapper.innerHTML = slideHtml;

    const swiper = new Swiper(swiperEl, {
        loop: true,
        slidesPerView: 3,
        breakpoints: {
            0: { slidesPerView: 1 },
            751: { slidesPerView: 3 }
        },
        spaceBetween: 20,
        grabCursor: true,
        speed: 450,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: '.customers_box .swiper-right',
            prevEl: '.customers_box .swiper-left',
        }
    });

    // 手动暂停/播放按钮
    playPauseBtn.addEventListener('click', () => {
        if(isUserPaused){
            // 当前是手动暂停，点击恢复
            isUserPaused = false;
            swiper.autoplay.start();
            playPauseBtn.innerText = 'Pause';
        }else{
            // 当前运行，点击手动暂停
            isUserPaused = true;
            swiper.autoplay.stop();
            playPauseBtn.innerText = 'Play';
        }
    });

    // 鼠标悬浮：只做临时暂停，不修改用户手动状态
    swiperEl.addEventListener('mouseenter', ()=> {
        swiper.autoplay.stop();
    });

    // 鼠标移出：只有用户没有手动暂停，才恢复播放
    swiperEl.addEventListener('mouseleave', ()=> {
        if(!isUserPaused){
            swiper.autoplay.start();
        }
    });
});
/* */
const MAX_ANGLE_X = 8;
const MAX_ANGLE_Y = 10;
const FOLLOW_SMOOTH = 0.22;
const RESET_TIME = 0.35;
const ROLL_DURATION = 0.4;     //翻滚到最大角度时长
const RECOVER_DURATION = 0.4; //平滑回退时长

function isPC() {
    return window.matchMedia('(min-width:769px)').matches;
}

const cubeList = document.querySelectorAll('.treedbox .box');
const wrapEl = document.querySelector('.treedbox .wrap');
const treedboxEl = document.querySelector('.treedbox');

// ========= PC端逻辑 =========
if(isPC()){
    cubeList.forEach(cube => {
        let rollTween = null;
        let recoverTween = null;
        let tiltTween = null;
        let isRollAnimating = false;

        function runRoll(angle) {
            if (rollTween) rollTween.kill();
            if (recoverTween) recoverTween.kill();
            isRollAnimating = true;

            rollTween = gsap.to(cube, {
                rotateX: angle,
                duration: ROLL_DURATION,
                ease: "power2.inOut",
                onComplete: () => {
                    recoverTween = gsap.to(cube, {
                        rotateX: 0,
                        duration: RECOVER_DURATION,
                        ease: "power2.out",
                        onComplete: () => {
                            isRollAnimating = false;
                        },
                        onInterrupt:()=>{
                            isRollAnimating = false;
                        }
                    });
                },
                onInterrupt: () => {
                    isRollAnimating = false;
                }
            })
        }

        cube.addEventListener('mouseenter', () => {
            runRoll(180);
        })

        cube.addEventListener('mousemove', (e) => {
            if(isRollAnimating) return;

            const rect = cube.getBoundingClientRect();
            // 鼠标相对于盒子中心点 -0.5 ~ +0.5
            const xPercent = ((e.clientX - rect.left) / rect.width) - 0.5;
            const yPercent = ((e.clientY - rect.top) / rect.height) - 0.5;

            // 直接计算绝对值角度，不再使用 += 累加
            const targetRotateY = xPercent * MAX_ANGLE_Y;
            const targetRotateX = -yPercent * MAX_ANGLE_X;

            if (tiltTween) tiltTween.kill();
            tiltTween = gsap.to(cube, {
                rotateX: targetRotateX,
                rotateY: targetRotateY,
                duration: FOLLOW_SMOOTH,
                ease: "power1.out"
            })
        })

        cube.addEventListener('mouseleave', () => {
            runRoll(-180);
            if (tiltTween) tiltTween.kill();
            tiltTween = gsap.to(cube, {
                rotateX: 0,
                rotateY: 0,
                duration: RESET_TIME,
                ease: "power2.out"
            })
        })
    })
}

// ========= 移动端touch逻辑【已优化：区分横纵向手势】 =========
if(!isPC() && treedboxEl && wrapEl){
    const originGapRem = 1;
    const dragFixedGapRem = 1.5;
    const animDuration = 1;
    let timeline = null;
    let hasTriggerAnim = false;
    let startX = 0;
    let startY = 0;

    treedboxEl.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        hasTriggerAnim = false;
    })

    treedboxEl.addEventListener('touchmove', (e) => {
        if(hasTriggerAnim) return;
        const moveX = e.touches[0].clientX;
        const moveY = e.touches[0].clientY;
        const deltaX = Math.abs(moveX - startX);
        const deltaY = Math.abs(moveY - startY);

        // 仅横向滑动大于纵向滑动时才触发gap动画，不干扰原生滚动
        if(deltaX > 8 && deltaX > deltaY){
            hasTriggerAnim = true;
            if(timeline) timeline.kill();
            timeline = gsap.timeline()
            .to(wrapEl, {
                '--box-gap': dragFixedGapRem,
                duration: animDuration * 1,
                ease:"power1.out"
            })
            .to(wrapEl, {
                '--box-gap': originGapRem,
                duration: animDuration * 1,
                ease:"power1.out"
            });
        }
    })

    treedboxEl.addEventListener('touchend', () => {
        hasTriggerAnim = false;
    })
}

// Swiper11 实例化【关键：touch:false 彻底关闭触摸模块，不拦截touch事件，保障容器横向滚动】
document.querySelectorAll('.forward .box-swiper').forEach(el=>{
  new Swiper(el,{
    loop:true,
    autoplay:{
      delay:1000,
      disableOnInteraction:false
    },
    allowTouchMove:false,
    touch: false, // Swiper11 关闭触摸模块，不注册touchstart/touchmove，事件正常冒泡
    speed:400,
  })
})